import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTwitterIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 35,
	viewBox: "0 0 36 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3550_22644)",
		children: /* @__PURE__ */ _jsx("path", { d: "M19.8616 15.4686L27.147 7H25.4206L19.0947 14.3532L14.0423 7H8.21484L15.8551 18.1193L8.21484 27H9.94134L16.6216 19.2348L21.9574 27H27.7848L19.8612 15.4686H19.8616ZM17.497 18.2173L16.7228 17.1101L10.5634 8.29967H13.2152L18.1859 15.4099L18.9601 16.5172L25.4214 25.7594H22.7696L17.497 18.2177V18.2173Z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3550_22644",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "translate(8 7)"
		})
	}) })]
});
export { SvgTwitterIcon as ReactComponent };
